import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader, Text } from '@cloudflare/kumo'
import { useTranslation } from '../i18n'

export function CallbackPage() {
  const { isAuthenticated, isLoading } = useAuth0()
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/wifi')
    }
  }, [isAuthenticated, isLoading, navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-kumo-base text-kumo-default">
      <Loader size="lg" />
      <Text variant="secondary">{t('callback.processing')}</Text>
    </div>
  )
}
